import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSheet,{staticClass:"pa-3",staticStyle:{"margin-bottom":"1px","background-color":"#CFD8DC"},attrs:{"elevation":"0","width":"100%"}},[_c('div',[_vm._v("Author: "),_c('b',[_vm._v(_vm._s(_vm.author))])]),_c('div',[_vm._v("Time: "),_c('b',[_vm._v(_vm._s(_vm.formatTime(_vm.time)))])]),_c('div',[_c('i',[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }